import React from 'react';
import { useLocation } from 'react-router-dom';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
// import CommonHeaderChat from './CommonHeaderChat';
// import Search from '../../../components/Search';
import CisCommonHeaderRight from './PurdyCommonHeaderRight';
import { purdyPagesMenu } from '../../../menu';

const PurdyHeader = () => {
	const location = useLocation();
	const currentUrl = location.pathname;
	// console.log(currentUrl);

	// console.log(nabuPagesMenu);

	const currentTitle = Object.keys(purdyPagesMenu).reduce(
		(title, key) => {
			const { path, pageTitle, subMenu } = purdyPagesMenu[key as keyof typeof purdyPagesMenu];
			if (path === currentUrl || `/${path}` === currentUrl) {
				return pageTitle || null;
			}
			if (subMenu) {
				const subMenuTitle = Object.keys(subMenu).reduce(
					(subTitle, subKey) => {
						const { path: subPath, pageTitle: subPageTitle } =
							subMenu[subKey as keyof typeof subMenu];
						return subPath === currentUrl || `/${subPath}` === currentUrl
							? subPageTitle || null
							: subTitle;
					},
					null as string | null,
				);
				if (subMenuTitle) return subMenuTitle;
			}
			return title;
		},
		null as string | null,
	);

	return (
		<Header>
			<div className='d-flex justify-content-end'>
				<HeaderLeft className='align-content-center'>
					<span
						style={{ fontSize: '22.75px', fontWeight: 700, color: 'black', margin: 0 }}>
						{currentTitle}
					</span>
				</HeaderLeft>
				<CisCommonHeaderRight /* afterChildren={<CommonHeaderChat />} */ />
			</div>
		</Header>
	);
};

export default PurdyHeader;
